export const IS_FETCHING = 'IS_FETCHING';

export const isFetching = (isFetching) => ({ type: IS_FETCHING, isFetching });


